<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.7273 15.9994L20.6852 10.8699L22.256 9.63202L26.7859 15.3804C27.072 15.7435 27.072 16.2553 26.7859 16.6183L22.256 22.3667L20.6852 21.1288L24.7273 15.9994Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.27318 15.9994L11.3153 10.8699L9.74445 9.63202L5.21456 15.3804C4.92848 15.7435 4.92848 16.2553 5.21456 16.6183L9.74445 22.3667L11.3153 21.1288L7.27318 15.9994Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.8385 24.524L17.2218 6.99084L19.162 7.47592L14.7787 25.0091L12.8385 24.524Z"
        />
    </svg>
</template>
